import { FlowBase } from "../../flow-base";
import IdentificationType from "../../Enums/identificationType";
import Events from "../../Enums/Events";
import Logger from "../../Overrides/Logger";
import FlowStep from "../../Enums/Flowstep";
import ConditionalClickPlacement from "../../Enums/ConditionalClickPlacement";
import { isCustomFailureResponse, isCustomSubscriptionExistsResponse, isCustomSuccessResponse } from "./FlowGuards/Guards";
//This did use to be flow-vodacom-za-tier2-tier1-identify and is the TS equivalent
//but the flow has changed since it was originally made
class VodacomZATier2NBAOTPLegacyID extends FlowBase {
    constructor() {
        super(...arguments);
        this.conditionalClick = true;
        this.userContentBlocked = false;
        this.userContentOverride = false;
    }
    iframeIdentify() {
        const startTime = Date.now();
        Logger.info("iframe call started", {
            event_type: 'iframe_start',
            timestamp: startTime,
        });
        if (!this.internalCall) {
            this.handleIntegratorIframeIdentity();
        }
        window.addEventListener('message', (event) => {
            var _a, _b;
            //event is the response data sent from the flow
            //call on message here and use the onSuccess onError defined above since the heResponse is the same
            const endTime = Date.now();
            Logger.info(`received iframe message event`, {
                event_type: 'iframe_response',
                timestamp: endTime,
                time_taken_ms: endTime - startTime,
                identified: (_a = event.data.identified) !== null && _a !== void 0 ? _a : null,
                reference: (_b = event.data.reference) !== null && _b !== void 0 ? _b : null,
            });
            this.customHandleStandardIdentifyResponse(event.data);
        }, false);
    }
    //have to override this function so that I can override onIdentifySuccess
    customHandleStandardIdentifyResponse(response) {
        switch (response.status_code) {
            case 200:
                if (isCustomSuccessResponse(response)) {
                    this.onCustomIdentifySuccess(response);
                }
                break;
            case 302:
                if (isCustomSubscriptionExistsResponse(response)) {
                    this.onCustomIdentifySubscriptionExists(response);
                }
                break;
            default:
                if (isCustomFailureResponse(response)) {
                    this.customOnIdentifyFailure(response);
                }
                break;
        }
    }
    //Overriden to destroy page if response.forbidden and handle content_blocked
    onCustomIdentifySuccess(response) {
        this.initialIdentifyLogic();
        if (response.forbidden) {
            this.destroyPageAndDisplayContentBlockNotice();
            return;
        }
        this.identity = response.identity;
        this.identified = response.identified;
        this.identifyCallFinished = true;
        if (this.identified) {
            Logger.debug('[Identity Success] id response', { "response": response });
            this.userContentBlocked = (typeof response.content_blocked !== 'undefined' && (response.content_blocked == 1 || response.content_blocked == "Y" || response.content_blocked == true));
            this.tracker.track(Events.IDENTIFY_SUCCESS);
            if (this.userContentBlocked) {
                this.tracker.track(Events.CONTENT_BLOCKED);
                this.userContentBlocked = true;
                this.setFlowStep(FlowStep.CONDITIONAL_CLICK);
            }
            else {
                this.tracker.track(Events.NOT_CONTENT_BLOCKED);
            }
        }
        else {
            Logger.debug(`[Identity Failure] id response`, { "response": response });
            this.tracker.track(Events.IDENTIFY_FAILURE, {
                reference: response.reference,
                status_code: response.status_code,
            });
            this.identifyBackup();
        }
    }
    onCustomIdentifySubscriptionExists(response) {
        this.initialIdentifyLogic();
        this.redirecting = true;
        // we set this field in all blocks to avoid isIdentifyCallFinished resolving before this.redirect is set
        this.identifyCallFinished = true;
        this.tracker.track(Events.SUBSCRIPTION_EXISTS, {
            data: {
                reference: response.reference,
            },
        });
        this.redirectToProduct(response.jwt);
    }
    customOnIdentifyFailure(response) {
        this.initialIdentifyLogic();
        Logger.info(`[Identity Failure] id response.`, { "response": response });
        this.tracker.track(Events.IDENTIFY_FAILURE, {
            reference: response.reference,
            status_code: response.status_code,
        });
        this.identifyCallFinished = true;
        this.identifyBackup();
    }
    handleIntegratorIframeIdentity() {
        //since heIframeIdentity has no error handled add a timeout then call identifyOnError
        this.iframeTimeout = window.setTimeout(() => {
            this.checkIdentify();
        }, this.identifyTimeout * 1000);
        const identifyUrl = this.integratorIdentifyUrl.split('?')[0];
        this.integrator.customHeIframeIdentify(identifyUrl, this.identifyEndpoint, {
            plan_id: parseInt(this.plan),
            locale: this.locale,
            return: window.location.href,
        });
    }
    onOTPSubmitWithCondition(response) {
        //Need to check if its conditional click otherwise throw an error
        if (response.conditions === null) {
            this.onOTPSubmitSuccess(response);
            return;
        }
        if (response.conditions.includes("content_blocked") && response.conditions_data["content_blocked"] !== undefined) {
            this.userContentBlocked = true;
            this.setFlowStep(FlowStep.OTP_VALIDATE);
            this.setFlowStep(FlowStep.CONDITIONAL_CLICK);
        }
        else if (response.conditions.includes("already_subscribed") && response.conditions_data["already_subscribed"] !== undefined) {
            this.redirectToProduct(response.conditions_data["already_subscribed"]["token"]);
        }
        else {
            this.setFlowStep(FlowStep.OTP_SUBMIT_ERROR);
        }
    }
    handleCancelResponse() {
        Logger.debug('[Tier 2] User declined and is redirecting');
        window.setTimeout(() => {
            window.open('https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill', '_self');
        }, 300);
    }
    subscribeOnError(response) {
        this.uiControl.hideElement(this.uiControl.controls.spinner);
        if (response.error == "carrier") {
            this.handleCarrierError(); //When the user subscribes with content_override it will return reason carrier
            //they want us to redirect to vodacom website then
            return;
        }
        if (response.code === 403) {
            Logger.error(`[Subscribe Error] Flow (${this.name}): fraud detected`, { "response": response });
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
            this.setFlowStep(FlowStep.FRAUD);
            this.dispatcher.dispatchFraudDetected({
                reference: response.reference,
                status_code: response.code,
                error: response.error || 'NO ERROR PROVIDED'
            });
            this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
        }
        else if (response.code === 402) {
            Logger.error(`[Subscribe Error] Flow (${this.name}): insufficent funds`, { "response": response });
            this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchSubscriptionFailed({
                reference: response.reference,
                status_code: response.code,
                error: response.error || 'NO ERROR PROVIDED',
            });
            this.uiControl.displayCustomMessage('You have insufficient funds. Please recharge and try again', '');
        }
        else {
            Logger.error(`[Subscribe Error] Flow (${this.name}): received error from integrator`, { "response": response });
            this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchSubscriptionFailed({
                reference: response.reference,
                status_code: response.code,
                error: response.error || 'NO ERROR PROVIDED',
            });
            this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
        }
    }
    onIdentifySuccessWithCondition(response) {
        this.identifyCallFinished = true;
        this.identified = true;
        this.identity = response.identity;
        this.tracker.track(Events.IDENTIFY_SUCCESS, {
            reference: response.reference,
            content_blocked: true,
        });
        if (response.conditions.includes("already_subscribed")) {
            this.onIdentifySubscriptionExists(response);
        }
        else if (response.conditions.includes("content_blocked")) {
            this.userContentBlocked = true;
            this.setFlowStep(FlowStep.CONDITIONAL_CLICK);
        }
    }
    onIdentifyFailure(response) {
        if (response.reason == "blocked") {
            this.onIdentifyForbidden(response);
        }
        else if (response.reason == 'non_subscriber') {
            this.initialIdentifyLogic();
            Logger.info(`[Identity Failure] id response.`, { "response": response });
            this.tracker.track(Events.IDENTIFY_FAILURE, {
                reference: response.reference,
            });
            this.identifyCallFinished = true;
            this.identifyBackup();
        }
        else {
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
        }
    }
    onIdentifyForbidden(response) {
        this.destroyPageAndDisplayContentBlockNotice();
    }
    destroyPageAndDisplayContentBlockNotice() {
        this.tracker.track(Events.IDENTIFY_SUCCESS);
        this.tracker.track(Events.FORBIDDEN);
        document.body.innerHTML = "";
        const notice = document.createElement('p');
        const pageName = typeof contentBlockPageName !== 'undefined' ? contentBlockPageName : 'this page';
        notice.innerHTML = `Your request to ${pageName} has been rejected due to the Content Block set on your Vodacom number. Please contact your Vodacom Administrator.`;
        notice.style.fontSize = "20px";
        document.body.appendChild(notice);
    }
    subscribeOnSuccess(response) {
        Logger.debug(`[Subscribe Success] Flow (${this.name}): received integrator response`, { "response": response });
        if (response.reason == "carrier") {
            this.handleCarrierError();
            return;
        }
        if (response.code == 200 && response.status == "subscribed") {
            this.setFlowStep(FlowStep.SUBSCRIPTION_SUCCEEDED);
            if (response.new) {
                this.dispatcher.dispatchSubscriptionSucceeded({
                    jwt: response.access_token || '',
                    reference: response.reference,
                });
            }
            else {
                this.tracker.track(Events.SUBSCRIPTION_EXISTS, {
                    data: {
                        reference: response.reference,
                    },
                });
                if (typeof response.access_token === 'undefined') {
                    Logger.error('Subscribed without an access token', { "response": response });
                }
                this.redirectToProduct(response.access_token || '');
            }
        }
        else if (response.status == "failed") {
            this.dispatcher.dispatchSubscriptionFailed({
                reference: response.reference,
                status_code: response.code,
                error: response.reason || 'NO ERROR PROVIDED',
            });
            if (response.reason == "insufficient_balance") {
                this.uiControl.displayCustomMessage('You have insufficient funds. Please recharge and try again');
            }
            else if (response.reason == "fraud") {
                this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
                this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
            }
            else {
                this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
                this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
            }
        }
    }
    handleCarrierError() {
        this.handleCancelResponse();
    }
    handleOtpChallengeValidate() {
        //After msisdn is submitted then the code is validated
        Logger.debug(`Flow (${this.name}): handling challenge validation`);
        this.setFlowStep(FlowStep.SPINNER);
        if (this.preSubscribe) {
            this.dispatcher.dispatchPreSubscribe();
        }
        const otpCode = this.uiControl.controls.otp.code;
        if (this.conditionalClick && this.userContentBlocked) {
            this.metadata.user_content_override = this.userContentOverride;
        }
        else {
            delete this.metadata.user_content_override;
        }
        const data = {
            metadata: this.metadata,
            subscription_data: this.metadata,
            marketing_data: this.metadata,
            locale: this.locale,
            product: this.productSlug,
            plan_id: parseInt(this.plan),
            territory: this.territory,
            identity: this.identity,
            fraud_transaction_id: this.fraud_detection_id,
            tracking_id: this.mixpanel_tracking_id,
            code: otpCode.value,
        };
        this.integrator.otpSubscribeCustomRequest(data, this.otpChallengeValidateURL, this.otpValidateSuccess.bind(this), this.otpValidateError.bind(this));
    }
    otpValidateSuccess(response) {
        Logger.debug(`[OTP Validate Success] Flow (${this.name}): received integrator response`, { "response": response });
        if (response.reason == "carrier") {
            this.handleCarrierError();
            return;
        }
        if (response.code == 200 && response.status == "subscribed") {
            this.setFlowStep(FlowStep.SUBSCRIPTION_SUCCEEDED);
            if (response.new) {
                this.dispatcher.dispatchSubscriptionSucceeded({
                    jwt: response.access_token || '',
                    reference: response.reference,
                });
            }
            else {
                this.tracker.track(Events.SUBSCRIPTION_EXISTS, {
                    data: {
                        reference: response.reference,
                    },
                });
                if (typeof response.access_token === 'undefined') {
                    Logger.error('Subscribed without an access token', { "response": response });
                }
                this.redirectToProduct(response.access_token || '');
            }
        }
        else if (response.status == "failed") {
            this.otpValidateFailure(response);
        }
        else {
            this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
        }
    }
    otpValidateFailure(response) {
        this.dispatcher.dispatchSubscriptionFailed({
            reference: response.reference,
            status_code: response.code,
            error: response.reason || 'NO ERROR PROVIDED',
        });
        if (response.reason == "otp_mismatch") {
            this.setFlowStep(FlowStep.OTP_VALIDATE_ERROR);
        }
        else if (response.reason == "insufficient_balance") {
            this.uiControl.displayCustomMessage('You have insufficient funds. Please recharge and try again');
        }
        else if (response.reason == "fraud") {
            this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
            this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
        }
        else {
            this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
        }
    }
    otpValidateError(response) {
        if (response.error == "carrier") {
            this.handleCarrierError();
            return;
        }
        Logger.error(`[OTP Validate] Flow (${this.name}): received error from integrator`, { "response": response });
        this.setFlowStep(FlowStep.SUBSCRIPTION_FAILED);
        this.dispatcher.dispatchSubscriptionFailed({
            reference: 'reference',
            status_code: response.code,
            error: response.error || 'NO ERROR PROVIDED',
        });
        this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
        return;
    }
    handleCancelError(error) {
        Logger.error('[Tier 2] Error returned from cancel endpoint', error);
        // below is commented out so user does not see error before they are redirected
        // this.uiControl.displayCustomMessage('A system error occurred and we could not complete the transaction');
    }
    handleCancelRequest() {
        this.setFlowStep(FlowStep.SPINNER);
        window.setTimeout(() => {
            window.open('https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill', '_self');
        }, 2500);
        // if (this.conditionalClick && this.userContentBlocked) {
        //     this.metadata.user_content_override = this.userContentOverride;
        // } else {
        //     delete this.metadata.user_content_override;
        // }
        // const data = {
        //     fraud_detection_id: this.metadata.fraud_transaction_id,
        //     identity: this.identity || "unindentified",
        //     metadata: this.metadata,
        //     mixpanel_tracking_id: this.metadata.event_tracking_id,
        // };
        // Logger.info('[Tier 2] Sending data to cancel', data)
        // this.integrator.customCancelRequest(data, 'lp/tier2/cancel', this.handleCancelResponse.bind(this), this.handleCancelError.bind(this))
    }
    handleConditionalClick() {
        this.setInactiveTimeout();
        this.tracker.track(Events.CONDITIONAL_CLICK, {
            'ContentOveride': true
        });
        this.userContentOverride = true;
        if (!this.identifyBackupCalled) {
            if (this.subscribeClick && this.conditionalClickPlacement === ConditionalClickPlacement.FIRST) { //conditional click was first so came before subscribe so show subscribe if enabled
                //if it is second then no check is needed confirm will always come after conditional click if conditional click was second
                this.setFlowStep(FlowStep.SUBSCRIBE);
            }
            else {
                this.setFlowStep(FlowStep.CONFIRM);
            }
        }
        else {
            this.setFlowStep(FlowStep.HIDE_CONTENT_CLICK);
        }
    }
    handleContentCancelClick() {
        this.setFlowStep(FlowStep.SPINNER);
        window.setTimeout(() => {
            window.open('https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill', '_self');
        }, 2500);
        // this.metadata.user_content_override = false;
        // const data = {
        //     fraud_detection_id: this.metadata.fraud_transaction_id,
        //     identity: this.identity || "unindentified",
        //     metadata: this.metadata,
        //     mixpanel_tracking_id: this.metadata.event_tracking_id,
        // };
        // Logger.info('[Tier 2] Sending data to cancel', data)
        // this.integrator.customCancelRequest(data, 'lp/tier2/cancel', this.handleCancelResponse.bind(this), this.handleCancelError.bind(this))
    }
    bindTrackingEvents() {
        this.dispatcher.addCancelClickListener(this.handleCancelRequest.bind(this));
        this.dispatcher.addContentCancelClickListener(this.handleContentCancelClick.bind(this));
        this.dispatcher.addFraudDetectedListener(this.handleFraudDetected.bind(this));
        this.dispatcher.addT2SubscriptionFailedListener(this.customHandleSubscriptionFailed.bind(this));
        this.dispatcher.addSubscriptionSucceededListener(this.handleSubscriptionSucceeded.bind(this));
    }
    customHandleSubscriptionFailed(event) {
        this.tracker.track(Events.SUBSCRIPTION_FAILED, {
            data: {
                reference: event.reference,
                status_code: event.status_code,
                error: event.error,
                response_string: event.response_string,
                content_blocked: event.content_blocked
            }
        });
    }
    subscribeUser() {
        if (this.identified) {
            Logger.debug('[Subscribe User] user is identified; attempting subscription');
            if (this.conditionalClick && this.userContentBlocked) {
                this.metadata.user_content_override = this.userContentOverride;
            }
            else {
                delete this.metadata.user_content_override;
            }
            const data = {
                metadata: this.metadata,
                subscription_data: this.metadata,
                marketing_data: this.metadata,
                identity: this.identity,
                fraud_transaction_id: this.metadata.fraud_detection_id || '',
                locale: this.locale,
                product: this.productSlug,
                plan_id: parseInt(this.plan),
                territory: this.territory,
                tracking_id: this.metadata.event_tracking_id || '',
            };
            this.integrator.customHeSubscribeRequest(data, this.subscribeEndpoint, this.subscribeOnSuccess.bind(this), this.subscribeOnError.bind(this));
        }
        else {
            this.identifyBackup();
        }
    }
    showFirstStep() {
        this.setFlowStep(FlowStep.CONFIRM);
    }
    redirectToProduct(jwt) {
        // remove unload message
        window.onbeforeunload = null;
        const redirectUrl = this.getProductRedirectUrl(this.productUrl, '', {
            auth: jwt
        });
        Logger.debug(`Flow (${this.name}): redirecting to product`, redirectUrl);
        this.tracker.track(Events.REDIRECT_TO_PRODUCT, {
            data: {
                redirectUrl: redirectUrl,
                withAuth: true
            },
        });
        window.location.assign(redirectUrl);
    }
    //Neededto handle the content click modal
    setFlowStep(flowStep) {
        Logger.debug(`Flow (${this.name}): changing step from ${this.step} to ${flowStep}`);
        this.step = flowStep;
        this.uiControl.setPageState(flowStep);
        //Some flowsteps are triggered in this flow for CSS purpose and therefore aren't included here. They can be added in the future though.
        switch (flowStep) {
            case FlowStep.CONFIRM:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.wifi);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.showElement(this.uiControl.controls.confirm);
                this.uiControl.showElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.showElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                this.tracker.track(Events.CTA_SHOWN);
                break;
            case FlowStep.OTP_CHALLENGE:
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.otp.error);
                this.uiControl.showElement(this.uiControl.controls.otp.container);
                this.uiControl.showElement(this.uiControl.controls.otp.challenge);
                this.uiControl.showElement(this.uiControl.controls.otp.msisdn);
                this.uiControl.showElement(this.uiControl.controls.otp.msisdnText);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                break;
            case FlowStep.OTP_VALIDATE:
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.otp.challenge);
                this.uiControl.hideElement(this.uiControl.controls.otp.error);
                this.uiControl.showElement(this.uiControl.controls.otp.validate);
                this.uiControl.hideElement(this.uiControl.controls.otp.msisdnText);
                this.uiControl.showElement(this.uiControl.controls.otp.validateText);
                break;
            case FlowStep.OTP_SUBMIT:
                this.uiControl.showElement(this.uiControl.controls.spinner);
                break;
            case FlowStep.OTP_VALIDATE_ERROR:
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.otp.challenge);
                this.uiControl.showElement(this.uiControl.controls.otp.validate);
                this.uiControl.hideElement(this.uiControl.controls.otp.msisdnText);
                this.uiControl.showElement(this.uiControl.controls.otp.validateText);
                break;
            case FlowStep.OTP_SUBMIT_ERROR:
                //Everything that happens in challenge
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                //But show the error instead
                this.uiControl.showElement(this.uiControl.controls.otp.error);
                break;
            case FlowStep.CONDITIONAL_CLICK:
                this.uiControl.hideElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.showElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.showElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.showElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                break;
            case FlowStep.WIFI:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.showElement(this.uiControl.controls.wifi);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                break;
            case FlowStep.SPINNER:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.showElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.hideElement(this.uiControl.controls.otp.validate);
                this.uiControl.hideElement(this.uiControl.controls.otp.challenge);
                this.uiControl.hideElement(this.uiControl.controls.otp.error);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                break;
            case FlowStep.SUBSCRIPTION_SUCCEEDED_CONTAINER:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.showElement(this.uiControl.controls.success.container);
                break;
            case FlowStep.FRAUD:
            case FlowStep.SUBSCRIPTION_FAILED:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                break;
            case FlowStep.TIMEOUT:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                this.uiControl.hideElement(this.uiControl.controls.otp.container);
                break;
            case FlowStep.IDENTIFY_FAILURE:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.tryForFree);
                this.uiControl.hideElement(this.uiControl.controls.spinner);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.subscribe);
                this.uiControl.hideElement(this.uiControl.controls.confirm);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickbox);
                this.uiControl.hideElement(this.uiControl.controls.consent.consentTickboxMessage);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                break;
            case FlowStep.HIDE_CONTENT_CLICK:
                this.uiControl.showElement(this.uiControl.controls.exit);
                this.uiControl.hideElement(this.uiControl.controls.contentClick.contentClickModalBackdrop);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.container);
                this.uiControl.hideElement(this.uiControl.controls.conditionalClick.button);
                break;
        }
    }
}
//THIS FLOW NEEDS A CONTENT CLICK MODAL OTHERWISE THE EXIT BTN WON'T BE DUPLICATED AND WILL BE HIDDEN
//DURING CONTENT CLICK
const VodacomZATier2NBAOTPLegacyIDFlowModule = new VodacomZATier2NBAOTPLegacyID('Vodacom ZA Tier 2 OTP', IdentificationType.IFRAME, {
    conditionalClick: true,
    otpChallengeValidateURL: 'subscribe/otp',
    optChallengeSubmitURL: 'identify/otp',
    OTP: true,
    conditionalClickPlacement: ConditionalClickPlacement.FIRST,
    subscribeEndpoint: 'subscribe/he',
    identifyEndpoint: 'he',
    inactiveTimeout: true,
});
window.FlowModule = VodacomZATier2NBAOTPLegacyIDFlowModule;
